module.exports = __webpack_public_path__ + "static/quizbaker-71a8174ee32afd1bd7ff7d6cd7d9839c.png";